/**
 * Máscaras de formulário YASY.
 * Porte de formatPhone() de app/lib/utils.ts — mesma regra: no máximo 11
 * dígitos, formato (99) 99999-9999, aplicada enquanto a pessoa digita.
 */
(function () {
  function formatarTelefone(valor) {
    var v = valor || '';
    // volta do servidor já em E.164 (+55…): tira o DDI antes de mascarar
    if (v.charAt(0) === '+') v = v.replace(/\D/g, '').replace(/^55/, '');
    var d = v.replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d;
    if (d.length <= 7) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  /**
   * O cadastro de cliente da Shopify (form 'customer') só aceita telefone em
   * E.164. A pessoa digita com máscara; no envio o campo vira +55DDNNNNNNNNN.
   * Número incompleto barra o envio aqui, antes de a Shopify recusar o
   * cadastro inteiro por causa dele. Campo vazio passa (é opcional).
   */
  function ligarE164(campo) {
    campo.form.addEventListener('submit', function (e) {
      var d = campo.value.replace(/\D/g, '');
      if (!d) return;
      if (d.length < 10 || d.length > 11) {
        e.preventDefault();
        campo.setCustomValidity('Informe o telefone com DDD, ex.: (11) 99999-9999.');
        campo.reportValidity();
        return;
      }
      campo.value = '+55' + d;
    });
  }

  function ligar(raiz) {
    var campos = (raiz || document).querySelectorAll('input[type="tel"]:not([data-yasy-mask])');
    Array.prototype.forEach.call(campos, function (campo) {
      campo.setAttribute('data-yasy-mask', 'tel');
      campo.setAttribute('inputmode', 'tel');
      campo.setAttribute('maxlength', '15');
      if (campo.value) campo.value = formatarTelefone(campo.value);
      if (campo.hasAttribute('data-yasy-e164') && campo.form) ligarE164(campo);
      campo.addEventListener('input', function () {
        campo.setCustomValidity('');
        var antes = campo.selectionStart;
        var tamanhoAntes = campo.value.length;
        campo.value = formatarTelefone(campo.value);
        // mantém o cursor no lugar quando se edita no meio do texto
        if (antes !== null && antes < tamanhoAntes) {
          var delta = campo.value.length - tamanhoAntes;
          campo.setSelectionRange(antes + delta, antes + delta);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ligar(document); });
  } else {
    ligar(document);
  }
  // o Theme Editor recarrega seções sem recarregar a página
  document.addEventListener('shopify:section:load', function (e) { ligar(e.target); });
})();
